const config = {
  apiUrl: "https://vb-api-lp.vyld.io",
};

export default config;
